import { render, staticRenderFns } from "./ModalWithdrawal.vue?vue&type=template&id=1532cb3a&"
import script from "./ModalWithdrawal.vue?vue&type=script&lang=js&"
export * from "./ModalWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports